module.exports = __webpack_public_path__ + "img/Rewards.9742f242.png";